import { DISCOUNTS_DEFAULT_SORTING_OPTION, DISCOUNTS_SORTING_OPTIONS } from './constants';

const discountsSortingOptionsByValue = DISCOUNTS_SORTING_OPTIONS.reduce((accumulator, option) => {
	accumulator[option.value] = option;

	return accumulator;
}, {});

export const getDiscountsSortingApiParams = (sorting = DISCOUNTS_DEFAULT_SORTING_OPTION.value) => {
	const option = discountsSortingOptionsByValue[sorting] || DISCOUNTS_DEFAULT_SORTING_OPTION;

	return {
		sort_by: option.sortBy,
		direction: option.direction,
	};
};
